module.exports = __webpack_public_path__ + "img/robot.3f291aeb.png";